module.exports = __webpack_public_path__ + "media/icons/cross-de64a431.png";